import { createAsyncThunk } from '@reduxjs/toolkit';
import UsersService from '../../../api/UsersService';
import { IUserWithTokens } from '../../../helpers/types';

export const asyncGetUsersAction = createAsyncThunk(
    'users/all',
    async ({ page, limit }: { page: number; limit: number }, thunkAPI) => {
        try {
            const response = await UsersService.findAll(page, limit);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncUpdateUserAction = createAsyncThunk(
    'users/update',
    async (
        { id, login, password }: { id: number; login: string; password?: string },
        thunkAPI
    ) => {
        try {
            const response = await UsersService.update(id, { login, password });
            return response.data as IUserWithTokens;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncDeleteTokenAction = createAsyncThunk(
    'users/deleteToken',
    async (
        { userId, tokenId }: { userId: number; tokenId: number },
        thunkAPI
    ) => {
        try {
            await UsersService.deleteToken(userId, tokenId);
            return { userId, tokenId };
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncCreateUserAction = createAsyncThunk(
    'users/create',
    async (
        { login, password, role }: { login: string; password: string; role: string },
        thunkAPI
    ) => {
        try {
            const created = await UsersService.create(login, password);
            const user = created.data as IUserWithTokens;

            await UsersService.setRole(user.id, role);

            const full = await UsersService.getOne(user.id);
            return full.data as IUserWithTokens;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncSetUserRoleAction = createAsyncThunk(
    'users/setRole',
    async ({ userId, title }: { userId: number; title: string }, thunkAPI) => {
        try {
            await UsersService.setRole(userId, title);
            const response = await UsersService.getOne(userId);
            return response.data as IUserWithTokens;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);
